<template>
	<div >
		<div v-show="tabPositiontype=='拜访'">
			<el-tabs v-model="activeName">
				<el-tab-pane label="远程拜访规则" name="first">
					<!-- 显示内容区 -->
					<div v-if="show">
						<div class="tb">
							<div style="flex:0 0 35%;height: 40px;">项目</div>
							<div
								style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
								设置值</div>
							<div style="flex:0 0 30%;text-align: right;height: 40px;">
								<el-button type="primary" size="small" @click="edit(0)">编辑</el-button>
							</div>
						</div>
						<div class="tbody">
							<div class="tr">
								<div class="name">拜访时间段</div>
								<div class="val">{{info.value.time_section}} </div>
							</div>
							<div class="tr">
								<div class="name">代表每日拜访同一医生最大次数</div>
								<div class="val">{{info.value.max_everyday_visit_doctor_times}} 次</div>
							</div>
							<div class="tr">
								<div class="name">代表每日拜访最大次数</div>
								<div class="val">{{info.value.max_everyday_visit_times}} 次</div>
							</div>
							<div class="tr">
								<div class="name">同一任务是否允许多次拜访同一医生</div>
								<div class="val" v-if="info.value.same_task_to_doctor=='0'">否</div>
								<div class="val" v-if="info.value.same_task_to_doctor=='1'">是</div>
							</div>
							
						</div>
					</div>
					<!-- 编辑内容区 -->
					<div v-if="isshow">
						<el-form ref="form" :model="form" label-width="160px" :rules="rules"
							style="width: 760px;">
							<el-form-item label="拜访时间段">
								<el-time-picker is-range v-model="value1" style="width: 100%;" format="HH:mm"
									value-format="HH:mm" range-separator="至" start-placeholder="开始时间"
									end-placeholder="结束时间" placeholder="选择时间范围" >
								</el-time-picker>
								<!-- <el-input v-model="form.time_section"></el-input> -->
							</el-form-item>
							<el-form-item label="代表每日拜访同一医生最大次数">
								<el-input v-model="form.max_everyday_visit_doctor_times">
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<el-form-item label="代表每日拜访最大次数">
								<el-input v-model="form.max_everyday_visit_times">
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<el-form-item label="同一任务是否允许多次拜访同一医生">
								<el-radio-group v-model="form.same_task_to_doctor">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="onSubmit(0)">保存</el-button>
								<el-button @click="clance(0)">返回</el-button>
							</el-form-item>
						</el-form>
		
					</div>
				</el-tab-pane>
				<el-tab-pane label="更新日志" name="second">
					<el-table :data="tableData" style="width: 100%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column label="操作前配置" width="370">
							<template slot-scope="{row}">
								<el-popover trigger="hover" placement="top" width="300">
									<p>{{JSON.stringify(row.new_value)}}</p>
									<div slot="reference">
										<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column label="操作后配置 " width="370">
							<template slot-scope="{row}">
								<el-popover trigger="hover" placement="top" width="300">
									<p>{{JSON.stringify(row.old_value)}}</p>
									<div slot="reference">
										<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column prop="create_time" width="180" label="操作时间">
						</el-table-column>
						<el-table-column prop="manager.real_name" label="操作人">
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="check(scope.row,0)" type="text" size="small">查看
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div style="text-align: right;margin-top: 50px;">
						<el-pagination @size-change="handleSizeChange" :page-sizes="[20]"
							@current-change="handleCurrentChange" :current-page="cur_page" :page-size="pageNum"
							layout="total,sizes,  prev, pager, next, jumper" :total="totalCount">
						</el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		
		<div v-show="tabPositiontype=='调研'">
			<el-tabs v-model="activeName1" ref="cases">
				<el-tab-pane label="远程调研规则" name="first1">
					<!-- 显示内容区 -->
					<div v-if="show1">
						<div class="tb">
							<div style="flex:0 0 35%;height: 40px;">项目</div>
							<div style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
								设置值</div>
							<div style="flex:0 0 30%;text-align: right;height: 40px;">
								<el-button type="primary" size="small" @click="edit(1)">编辑</el-button>
							</div>
						</div>
						<div class="tbody">
							
							<div class="tr">
								<div class="name">调研时间段</div>
								<div class="val">{{info.value.time_section}} </div>
							</div>
							<div class="tr">
								<div class="name">代表每日调研同一医生最大次数</div>
								<div class="val">{{info.value.max_everyday_visit_doctor_times}} 次</div>
							</div>
							<div class="tr">
								<div class="name">代表每日调研最大次数</div>
								<div class="val">{{info.value.max_everyday_visit_times}} 次</div>
							</div>
							<div class="tr">
								<div class="name">同一任务是否允许多次调研同一医生</div>
								<div class="val" v-if="info.value.same_task_to_doctor=='0'">否</div>
								<div class="val" v-if="info.value.same_task_to_doctor=='1'">是</div>
							</div>
							
							
							</div>
						</div>
					<!-- 编辑内容区 -->
					<div v-if="isshow1">
						<el-form ref="form" :model="form1" label-width="160px" :rules="rules"
							style="width: 760px;">
							<el-form-item label="调研时间段">
								<el-time-picker is-range v-model="value2" style="width: 100%;" format="HH:mm"
									value-format="HH:mm" range-separator="至" start-placeholder="开始时间"
									end-placeholder="结束时间" placeholder="选择时间范围" >
								</el-time-picker>
								<!-- <el-input v-model="form.time_section"></el-input> -->
							</el-form-item>
							<el-form-item label="代表每日调研同一医生最大次数">
								<el-input v-model="form1.max_everyday_visit_doctor_times">
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<el-form-item label="代表每日调研最大次数">
								<el-input v-model="form1.max_everyday_visit_times">
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<el-form-item label="同一任务是否允许多次调研同一医生">
								<el-radio-group v-model="form1.same_task_to_doctor">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="onSubmit(1)">保存</el-button>
								<el-button @click="clance(1)">返回</el-button>
							</el-form-item>
						</el-form>
					</div>
				</el-tab-pane>
				<el-tab-pane label="更新日志" name="second1">
					<el-table :data="tableData" style="width: 100%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column label="操作前配置" width="370">
							<template slot-scope="{row}">
								<el-popover trigger="hover" placement="top" width="300">
									<p>{{JSON.stringify(row.new_value)}}</p>
									<div slot="reference">
										<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column label="操作后配置 " width="370">
							<template slot-scope="{row}">
								<el-popover trigger="hover" placement="top" width="300">
									<p>{{JSON.stringify(row.old_value)}}</p>
									<div slot="reference">
										<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column prop="create_time" width="180" label="操作时间">
						</el-table-column>
						<el-table-column prop="manager.real_name" label="操作人">
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="check(scope.row,1)" type="text" size="small">查看
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div style="text-align: right;margin-top: 50px;">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100"
							layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
						</el-pagination>
					</div>
				</el-tab-pane>
		
			</el-tabs>
		
		</div>
		<div  v-show="tabPositiontype=='科室会'">
			<el-tabs v-model="activeName2" ref="cases1">
				<el-tab-pane label="远程科室会规则" name="first2">
					<!-- 显示内容区 -->
					<div v-if="show2">
						<div class="tb">
							<div style="flex:0 0 35%;height: 40px;">项目</div>
							<div
								style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
								设置值</div>
							<div style="flex:0 0 30%;text-align: right;height: 40px;">
								<el-button type="primary" size="small" @click="edit(2)">编辑</el-button>
							</div>
						</div>
						<div class="tbody">
							<div class="tr">
								<div class="name">举行会议时间段</div>
								<div class="val">{{info.value.time_section}} </div>
							</div>
							<div class="tr">
								<div class="name">最小会议时长</div>
								<div class="val">{{info.value.min_meeting_time}} 分钟</div>
							</div>
							<div class="tr">
								<div class="name">最少参会人数</div>
								<div class="val">{{info.value.min_join_meeting_person}} 人</div>
							</div>
							<div class="tr">
								<div class="name">代表每周指派统一医生会议最大次数</div>
								<div class="val">{{info.value.max_week_meeting_doctor_times}} 次</div>
							</div>
							<div class="tr">
								<div class="name">代表每周召开会议最大次数</div>
								<div class="val">{{info.value.max_week_meeting_times}} 次</div>
							</div>
							<div class="tr">
								<div class="name">同一任务是否允许多次指派同一医生</div>
								<div class="val" v-if="info.value.same_task_to_doctor=='0'">否</div>
								<div class="val" v-if="info.value.same_task_to_doctor=='1'">是</div>
							</div>
						</div>
					</div>
					<!-- 编辑内容区 -->
					<div v-if="isshow2">
						<el-form ref="form" :model="form2" label-width="160px" :rules="rules"
							style="width: 700px;">
							
							<el-form-item label="举行会议时间段">
								<el-time-picker is-range v-model="value3" style="width: 100%;" format="HH:mm"
									value-format="HH:mm" range-separator="至" start-placeholder="开始时间"
									end-placeholder="结束时间" placeholder="选择时间范围" >
								</el-time-picker>
							</el-form-item>
							<el-form-item label="最小会议时长">
								<el-input v-model="form2.min_meeting_time">
									<template slot="append">分钟</template>
								</el-input>
							</el-form-item>
							<el-form-item label="最小参会人数">
								<el-input v-model="form2.min_join_meeting_person">
									<template slot="append">人</template>
								</el-input>
							</el-form-item>
							
							<el-form-item label="代表每周指派同一医生会议最大次数">
								<el-input v-model="form2.max_week_meeting_doctor_times">
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<el-form-item label="代表每周召开会议最大次数">
								<el-input v-model="form2.max_week_meeting_times">
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<el-form-item label="同一任务是否允许多次指派同一医生">
								<el-radio-group v-model="form2.same_task_to_doctor">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="onSubmit(2)">保存</el-button>
								<el-button @click="clance(2)">返回</el-button>
							</el-form-item>
						</el-form>
					</div>
				</el-tab-pane>
				<el-tab-pane label="更新日志" name="second2">
					<el-table :data="tableData" style="width: 100%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column label="操作前配置" width="370">
							<template slot-scope="{row}">
								<el-popover trigger="hover" placement="top" width="300">
									<p>{{JSON.stringify(row.new_value)}}</p>
									<div slot="reference">
										<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column label="操作后配置 " width="370">
							<template slot-scope="{row}">
								<el-popover trigger="hover" placement="top" width="300">
									<p>{{JSON.stringify(row.old_value)}}</p>
									<div slot="reference">
										<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column prop="create_time" width="180" label="操作时间">
						</el-table-column>
						<el-table-column prop="manager.real_name" label="操作人">
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="check(scope.row,2)" type="text" size="small">查看
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div style="text-align: right;margin-top: 50px;">
						<el-pagination @size-change="handleSizeChange" :page-sizes="[20]"
							@current-change="handleCurrentChange" :current-page="cur_page" :page-size="pageNum"
							layout="total,sizes,  prev, pager, next, jumper" :total="totalCount">
						</el-pagination>
					</div>
				</el-tab-pane>
		
			</el-tabs>
		
		
		
		
		
		</div>
		<div v-show="tabPositiontype=='沙龙会'">
			<el-tabs v-model="activeName3" ref="cases2">
				<el-tab-pane label="远程沙龙会规则" name="first3">
					<!-- 显示内容区 -->
					<div v-if="show3">
						<div class="tb">
							<div style="flex:0 0 35%;height: 40px;">项目</div>
							<div
								style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
								设置值</div>
							<div style="flex:0 0 30%;text-align: right;height: 40px;">
								<el-button type="primary" size="small" @click="edit(3)">编辑</el-button>
							</div>
						</div>
						<div class="tbody">
							
							<div class="tr">
								<div class="name">举行会议时间段</div>
								<div class="val">{{info.value.time_section}}</div>
							</div>
							<div class="tr">
								<div class="name">最小会议时长</div>
								<div class="val">{{info.value.min_meeting_time}} 分钟</div>
							</div>
							<div class="tr">
								<div class="name">最少参会人数</div>
								<div class="val">{{info.value.min_join_meeting_person}} 人</div>
							</div>
							
							<div class="tr">
								<div class="name">代表每月指派同一医生会议最大次数</div>
								<div class="val">{{info.value.max_month_meeting_doctor_times}} 次</div>
							</div>
							<div class="tr">
								<div class="name">代表每月召开会议最大次数</div>
								<div class="val">{{info.value.max_month_meeting_times}} 次</div>
							</div>
							<div class="tr">
								<div class="name">同一任务是否允许多次指派同一医生</div>
								<div class="val" v-if="info.value.same_task_to_doctor=='0'">否</div>
								<div class="val" v-if="info.value.same_task_to_doctor=='1'">是</div>
							</div>
						</div>
					</div>
					<!-- 编辑内容区 -->
					<div v-if="isshow3">
						<el-form ref="form" :model="form3" label-width="160px" :rules="rules"
							style="width: 700px;">
							
							<el-form-item label="举行会议时间段">
								<el-time-picker is-range v-model="value4" style="width: 100%;" format="HH:mm"
									value-format="HH:mm" range-separator="至" start-placeholder="开始时间"
									end-placeholder="结束时间" placeholder="选择时间范围" >
								</el-time-picker>
							</el-form-item>
							<el-form-item label="最小会议时长">
								<el-input v-model="form3.min_meeting_time">
									<template slot="append">分钟</template>
								</el-input>
							</el-form-item>
							<el-form-item label="最少参会人数">
								<el-input v-model="form3.min_join_meeting_person">
									<template slot="append">人</template>
								</el-input>
							</el-form-item>
							
							<el-form-item label="代表每月指派同一医生会议最大次数">
								<el-input v-model="form3.max_month_meeting_doctor_times">
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<el-form-item label="代表每月召开会议最大次数">
								<el-input v-model="form3.max_month_meeting_times">
									<template slot="append">次</template>
								</el-input>
							</el-form-item>
							<el-form-item label="同一任务是否允许多次指派同一医生">
								<el-radio-group v-model="form3.same_task_to_doctor">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="onSubmit(3)">保存</el-button>
								<el-button @click="clance(3)">返回</el-button>
							</el-form-item>
						</el-form>
					</div>
				</el-tab-pane>
				<el-tab-pane label="更新日志" name="second3">
					<el-table :data="tableData" style="width: 100%">
						<el-table-column type="index" label="序号" width="50">
						</el-table-column>
						<el-table-column label="操作前配置" width="380">
							<template slot-scope="{row}">
								<el-popover trigger="hover" placement="top" width="300">
									<p>{{JSON.stringify(row.new_value)}}</p>
									<div slot="reference">
										<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column label="操作后配置 " width="380">
							<template slot-scope="{row}">
								<el-popover trigger="hover" placement="top" width="300">
									<p>{{JSON.stringify(row.old_value)}}</p>
									<div slot="reference">
										<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
									</div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column prop="create_time" width="180" label="操作时间">
						</el-table-column>
						<el-table-column prop="manager.real_name" label="操作人">
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="check(scope.row,3)" type="text" size="small">查看
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div style="text-align: right;margin-top: 50px;">
						<el-pagination @size-change="handleSizeChange" :page-sizes="[20]"
							@current-change="handleCurrentChange" :current-page="cur_page" :page-size="pageNum"
							layout="total,sizes,  prev, pager, next, jumper" :total="totalCount">
						</el-pagination>
					</div>
				</el-tab-pane>
		
			</el-tabs>
		
		</div>
		<el-drawer title="查看更新日志详情" :visible.sync="drawer" :direction="direction" size="40%">
			<div style="padding: 20px;">
				<div style="font-size: 18px;font-weight: bold;margin-bottom: 20px;">基础信息</div>
				<div class="flex">
					<div style="margin-right: 20px;">操作人：{{popinfo.manager.real_name}}</div>
					<div>编辑时间：{{popinfo.create_time}}</div>
				</div>
			</div>
			<div style="font-size: 18px;font-weight: bold;padding: 0 20px;">变更日志</div>
			<div style="padding: 20px;" v-if="tabPositiontype=='拜访'">
				<div class="tb">
					<div style="flex:0 0 40%;height: 40px;">项目</div>
					<div style="flex:0 0 60%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
						设置值</div>
				</div>
				<div class="tbody">
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">拜访时间段</div>
						<div class="val">{{popinfo.new_value.time_section}} <span class="compare"
								v-if="popinfo.compare_value.time_section==0">{{popinfo.old_value.time_section}}</span>
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">同一任务是否允许多次拜访同一医生</div>
						<div class="val">{{popinfo.new_value.same_task_to_doctor=='0'?'否':'是'}}
						<span class="compare"
								v-if="popinfo.compare_value.same_task_to_doctor==0">{{popinfo.old_value.same_task_to_doctor=='0'?'否':'是'}}</span>
						</div>
						
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">代表每日拜访同一医生最大次数</div>
						<div class="val">
						{{popinfo.new_value.max_everyday_visit_doctor_times}} <span class="compare"
								v-if="popinfo.compare_value.max_everyday_visit_doctor_times==0">{{popinfo.old_value.max_everyday_visit_doctor_times}}</span>
						次</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">代表每日拜访最大次数</div>
						<div class="val">
						{{popinfo.new_value.max_everyday_visit_times}} <span class="compare"
								v-if="popinfo.compare_value.max_everyday_visit_times==0">{{popinfo.old_value.max_everyday_visit_times}}</span>
						次</div>
					</div>
					
				</div>
			</div>
		
		
			<div style="padding: 20px;" v-if="tabPositiontype=='调研'">
				<div class="tb">
					<div style="flex:0 0 40%;height: 40px;">项目</div>
					<div style="flex:0 0 60%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
						设置值</div>
				</div>
				<div class="tbody">
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">调研时间段</div>
						<div class="val">{{popinfo.new_value.time_section}} <span class="compare"
								v-if="popinfo.compare_value.time_section==0">{{popinfo.old_value.time_section}}</span>
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">同一任务是否允许多次调研同一医生</div>
						<div class="val">{{popinfo.new_value.same_task_to_doctor=='0'?'否':'是'}}
						<span class="compare"
								v-if="popinfo.compare_value.same_task_to_doctor==0">{{popinfo.old_value.same_task_to_doctor=='0'?'否':'是'}}</span>
						</div>
						
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">代表每日调研同一医生最大次数</div>
						<div class="val">
						{{popinfo.new_value.max_everyday_visit_doctor_times}} <span class="compare"
								v-if="popinfo.compare_value.max_everyday_visit_doctor_times==0">{{popinfo.old_value.max_everyday_visit_doctor_times}}</span>
						次</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">代表每日调研最大次数</div>
						<div class="val">
						{{popinfo.new_value.max_everyday_visit_times}} <span class="compare"
								v-if="popinfo.compare_value.max_everyday_visit_times==0">{{popinfo.old_value.max_everyday_visit_times}}</span>
						次</div>
					</div>
					
				</div>
			</div>
		
			<div style="padding: 20px;"  v-if="tabPositiontype=='科室会'">
				<div class="tb">
					<div style="flex:0 0 40%;height: 40px;">项目</div>
					<div
						style="flex:0 0 60%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
						设置值</div>
				</div>
				<div class="tbody">
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">举行会议时间段</div>
						<div class="val">{{popinfo.new_value.time_section}} <span class="compare"
								v-if="popinfo.compare_value.time_section==0">{{popinfo.old_value.time_section}}</span>
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">最小会议时长</div>
						<div class="val">{{popinfo.new_value.min_meeting_time}} <span class="compare"
								v-if="popinfo.compare_value.min_meeting_time==0">{{popinfo.old_value.min_meeting_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">最少参会人数</div>
						<div class="val">{{popinfo.new_value.min_join_meeting_person}} <span class="compare"
								v-if="popinfo.compare_value.min_join_meeting_person==0">{{popinfo.old_value.min_join_meeting_person}}</span>人
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">代表每周指派同一医生会议最大次数</div>
						<div class="val">{{popinfo.new_value.max_week_meeting_doctor_times}} <span class="compare"
								v-if="popinfo.compare_value.max_week_meeting_doctor_times==0">{{popinfo.old_value.max_week_meeting_doctor_times}}</span>次
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">代表每周召开会议最大次数</div>
						<div class="val">{{popinfo.new_value.max_week_meeting_times}} <span class="compare"
								v-if="popinfo.compare_value.max_week_meeting_times==0">{{popinfo.old_value.max_week_meeting_times}}</span>次
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">同一任务是否允许多次指派同一医生</div>
						<div class="val">{{popinfo.new_value.same_task_to_doctor=='0'?'否':'是'}}
						<span class="compare"
								v-if="popinfo.compare_value.same_task_to_doctor==0">{{popinfo.old_value.same_task_to_doctor=='0'?'否':'是'}}</span>
						</div>
					</div>
					
				</div>
		
		
			</div>
		
		
			<div style="padding: 20px;" v-if="tabPositiontype=='沙龙会'">
		
				<div class="tb">
					<div style="flex:0 0 40%;height: 40px;">项目</div>
					<div
						style="flex:0 0 60%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
						设置值</div>
				</div>
				<div class="tbody">
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">举行会议时间段</div>
						<div class="val">{{popinfo.new_value.time_section}} <span class="compare"
								v-if="popinfo.compare_value.time_section==0">{{popinfo.old_value.time_section}}</span>
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">最小会议时长</div>
						<div class="val">{{popinfo.new_value.min_meeting_time}} <span class="compare"
								v-if="popinfo.compare_value.min_meeting_time==0">{{popinfo.old_value.min_meeting_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">最少参会人数</div>
						<div class="val">{{popinfo.new_value.min_join_meeting_person}} <span class="compare"
								v-if="popinfo.compare_value.min_join_meeting_person==0">{{popinfo.old_value.min_join_meeting_person}}</span>人
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">代表每月指派同一医生会议最大次数</div>
						<div class="val">{{popinfo.new_value.max_month_meeting_doctor_times}} <span class="compare"
								v-if="popinfo.compare_value.max_month_meeting_doctor_times==0">{{popinfo.old_value.max_month_meeting_doctor_times}}</span>次
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">代表每月召开会议最大次数</div>
						<div class="val">{{popinfo.new_value.max_month_meeting_times}} <span class="compare"
								v-if="popinfo.compare_value.max_month_meeting_times==0">{{popinfo.old_value.max_month_meeting_times}}</span>次
						</div>
					</div>
					<div class="tr">
						<div class="name" style="flex: 0 0 40%;">同一任务是否允许多次指派同一医生</div>
						<div class="val">{{popinfo.new_value.same_task_to_doctor=='0'?'否':'是'}}
						<span class="compare"
								v-if="popinfo.compare_value.same_task_to_doctor==0">{{popinfo.old_value.same_task_to_doctor=='0'?'否':'是'}}</span>
						</div>
					</div>
					
				</div>
		
			</div>
		
		
		</el-drawer>
	</div>
</template>

<script>
	export default {
	  props: ['tabPositiontype','type','companyvalue'],
	  data() {
		  return {
			  value2: [new Date(), new Date()],
			  value1: [new Date(), new Date()],
			  value3: [new Date(), new Date()],
			  value4: [new Date(), new Date()],
			  rules: {
			  	region: [{
			  		required: true,
			  		message: '请选择活动区域',
			  		trigger: 'change'
			  	}],
			  },
			popinfo: {
				manager: {},
				new_value: {
					other_rule: {}
				},
				old_value: {
					other_rule: {}
				},
				compare_value: {
					other_rule: {}
				}
			},
		  activeName:'first',
		  activeName1: 'first1',
		  activeName2: 'first2',
		  activeName3: 'first3',
		  drawer: false,
		  drawer1: false,
		  drawer2: false,
		  drawer3: false,
		  direction: 'rtl',
		  cur_page: 1, //默认在第一页
		  pageNum: 20, //默认每页显示1条数据
		  currentPage: 1,
		  totalCount: 0,
		  tableData: [],
		  show: true,
		  isshow: false,
		  show1: true,
		  isshow1: false,
		  show2: true,
		  isshow2: false,
		  show3: true,
		  isshow3: false,
		  form: {
		  	same_task_to_doctor: 0,
			other_rule:[]
		  },
		  form1: {
		  	same_task_to_doctor: 0,
			other_rule:[]
		  },
		  form2: {
			same_task_to_doctor: 0,
			other_rule:[]
		  },
		  form3: {
			same_task_to_doctor: 0,
			other_rule:[]
		  },
		  info: {
		  	id: null,
		  	value: {
		  		
		  	}
		  },
		  }
		  
	  },
	  created() {
	  	this.getPromoterData()
		
	  },
	  methods: {
		  check(row, i) {
		  	this.popinfo = row
		  	this.drawer = true;
		  },
		  onSubmit(i) {
		  	this.submitCofig(i);
		  
		  },
		  submitCofig(i) {
		  	let params
		  	this.$refs['form'].validate((valid) => {
		  		if (valid) {
		  			const loading = this.$loading({
		  				lock: true
		  			});
		  			if (this.type == 'survey') {
		  				let s,
		  					e
		  				if (this.info.id !== null) {
		  					s = this.value2[0]
		  					e = this.value2[1]
		  				} else {
		  					if (typeof(this.value2[0]) == 'object') {
		  						s = this.filterTime(this.value2[0])
		  						e = this.filterTime(this.value2[1])
		  					} else {
		  						s = this.value2[0]
		  						e = this.value2[1]
		  					}
		  				}
		  				this.form1.time_section = s + '~' + e
		  				params = {
		  					company_id: this.companyvalue,
		  					type: this.type,
		  					...this.form1
		  				}
		  			}
		  			if (this.type == 'payvisit') {
		  				let s,
		  					e
		  				if (this.info.id !== null) {
		  					s = this.value1[0]
		  					e = this.value1[1]
		  				} else {
		  					if (typeof(this.value1[0]) == 'object') {
		  						s = this.filterTime(this.value1[0])
		  						e = this.filterTime(this.value1[1])
		  					} else {
		  						s = this.value1[0]
		  						e = this.value1[1]
		  					}
		  
		  				}
		  
		  				this.form.time_section = s + '~' + e
		  				params = {
		  					company_id: this.companyvalue,
		  					type: this.type,
		  					...this.form
		  				}
		  			}
		  			if (this.type == 'depmeeting') {
						let s,
							e
						if (this.info.id !== null) {
							s = this.value3[0]
							e = this.value3[1]
						} else {
							if (typeof(this.value3[0]) == 'object') {
								s = this.filterTime(this.value3[0])
								
								e = this.filterTime(this.value3[1])
							} else {
								s = this.value3[0]
								e = this.value3[1]
							}
								  
						}
						this.form2.time_section = s + '~' + e
		  				params = {
		  					company_id: this.companyvalue,
		  					type: this.type,
		  					...this.form2
		  				}
		  			}
		  			if (this.type == 'salon') {
						let s,
							e
						if (this.info.id !== null) {
							s = this.value4[0]
							e = this.value4[1]
						} else {
							if (typeof(this.value4[0]) == 'object') {
								s = this.filterTime(this.value4[0])
								e = this.filterTime(this.value4[1])
							} else {
								s = this.value4[0]
								e = this.value4[1]
							}
								  
						}
						  
						this.form3.time_section = s + '~' + e
		  				params = {
		  					company_id: this.companyvalue,
		  					type: this.type,
		  					...this.form3
		  				}
		  			}
		  			// params.allowed_drag = params.allowed_drag == true ? '1' : '0';
					params.belong_to='remote'
		  			this.$http.post('/ExecuteRule/update', params).then(res => {
		  				loading.close();
		  				if (res.data.status == 1) {
		  					this.getPromoterData()
		  					if (i == 0) {
		  						this.isshow = false;
		  						this.show = true
		  					} else if (i == 1) {
		  						this.isshow1 = false;
		  						this.show1 = true
		  					} else if (i == 2) {
		  						this.isshow2 = false;
		  						this.show2 = true
		  					} else if (i == 3) {
		  						this.isshow3 = false;
		  						this.show3 = true
		  					}
							this.$emit('clancechanges', {index:i,clanceShow:true});
		  				}
		  
		  			})
		  		} else {
		  			return false;
		  		}
		  	});
		  },
		  clance(i) {
		  	if (i == 0) {
		  		this.isshow = false;
		  		this.show = true
		  	} else if (i == 1) {
		  		this.isshow1 = false;
		  		this.show1 = true
		  	} else if (i == 2) {
		  		this.isshow2 = false;
		  		this.show2 = true
		  	} else if (i == 3) {
		  		this.isshow3 = false;
		  		this.show3 = true
		  	}
			this.$emit('clancechanges', {index:i,clanceShow:true});
		  },
		  edit(i) {
		  	this.getPromoterData()
		  	if (this.info.id != null) {
		  		if (i == 0) {
		  			this.form = JSON.parse(JSON.stringify(this.info.value))
		  			this.value1 = this.form.time_section.split('~')
		  			// this.form.allowed_drag = this.form.allowed_drag == '1' ? true : false;
		  		} else if (i == 1) {
		  			this.form1 = JSON.parse(JSON.stringify(this.info.value))
		  			this.value2 = this.form1.time_section.split('~')
		  			// this.form1.allowed_drag = this.form1.allowed_drag == '1' ? true : false;
		  		} else if (i == 2) {
		  			this.form2 = JSON.parse(JSON.stringify(this.info.value))
					this.value3 = this.form2.time_section.split('~')
					
		  			// this.form2.allowed_drag = this.form2.allowed_drag == '1' ? true : false;
		  		} else if (i == 3) {
		  			this.form3 = JSON.parse(JSON.stringify(this.info.value))
					this.value4 = this.form3.time_section.split('~')
		  			// this.form3.allowed_drag = this.form3.allowed_drag == '1' ? true : false;
		  		}
		  	}
			
		  	if (i == 0) {
		  		this.isshow = true;
		  		this.show = false
		  	} else if (i == 1) {
		  		this.isshow1 = true;
		  		this.show1 = false
		  	} else if (i == 2) {
		  		this.isshow2 = true;
		  		this.show2 = false
		  	} else if (i == 3) {
		  		this.isshow3 = true;
		  		this.show3 = false
		  	}
			this.$emit('changes', {index:i,clanceShow:false});
		  },
		  async getPromoterData() {
		  	let result = await this.$http.post('/ExecuteRule/getRule', {
		  		company_id: this.companyvalue,
		  		type: this.type,
				belong_to:'remote'
		  	});
		  	if (result.data.status === 1) {
		  		if (result.data.data != null) {
		  			this.info = result.data.data
		  			this.getlist()
		  		} else {
		  			this.info = {
		  				id: null,
		  				value: {
		  					
		  				}
		  			}
		  		}
		  	}
		  },
		  async checkgetPromoterData(id) {
		  	let result = await this.$http.post('/ExecuteRule/getRule', {
		  		company_id: id,
		  		type: this.type,
		  				belong_to:'remote'
		  	});
		  	if (result.data.status === 1) {
		  		if (result.data.data != null) {
		  			this.info = result.data.data
		  			this.getlist()
		  		} else {
		  			this.info = {
		  				id: null,
		  				value: {
		  					
		  				}
		  			}
		  		}
		  
		  	}
		  },
		  async getlist() {
		  	let result = await this.$http.post('/ExecuteRule/getList', {
		  		pageSize: this.pageNum,
		  		ruleId: this.info.id,
		  		page: this.cur_page,
		  		type: this.type,
				
		  	});
		  	if (result.data.status === 1) {
		  		this.tableData = result.data.data.data_list;
		  		this.totalCount = result.data.data.count;
		  	}
		  },
		  handleSizeChange(val) {
		  	this.pageNum = val;
		  	this.getlist(); //根据用户获取的每页显示页面数量显示页面
		  },
		  handleCurrentChange(val) {
		  	this.cur_page = val;
		  	this.getlist(); //获取用户点击的当前页后刷新页面数据
		  },
		  filterTime(time) {
		  	var date = new Date(time);
		  	var y = date.getFullYear();
		  	var m = date.getMonth() + 1;
		  	m = m < 10 ? "0" + m : m;
		  	var d = date.getDate();
		  	d = d < 10 ? "0" + d : d;
		  	var h = date.getHours();
		  	h = h < 10 ? "0" + h : h;
		  	var minute = date.getMinutes();
		  	minute = minute < 10 ? "0" + minute : minute;
		  	var s = date.getSeconds();
		  	s = s < 10 ? "0" + s : s;
		  	return h + ":" + minute;
		  }
	  }
	};
</script>

<style lang="scss" scoped>
	.ts{
		position: relative;
		padding-left: 10px;
	}
	.ts::after{
		content: '';
		position: absolute;
		left: 0;
		top:6px;
		background: rgba(2, 167, 240, 1);
		width: 3px;
		    height: 20px;
	}
	.account-config-card {
		background: #fff;
		padding: 32px;
		border-radius: 10px;
		padding-bottom: 50px;


	}

	.tb {
		width: 800px;
		height: 40px;
		line-height: 40px;
		display: flex;
		align-items: center;
		border: 1px solid rgba(217, 217, 217, 1);
		padding: 0 10px;
		background: rgba(250, 250, 250, 1);
	}

	.tbody {
		border-left: 1px solid rgba(217, 217, 217, 1);
		border-right: 1px solid rgba(217, 217, 217, 1);
		width: 800px;

		.tr {
			padding: 0 10px;
			display: flex;
			border-bottom: 1px solid rgba(217, 217, 217, 1);
			align-items: center;

			.name {
				flex: 0 0 35%;
				padding: 10px 0;
			}

			.val {
				flex: 0 0 70%;
				padding-left: 10px;
				border-left: 1px solid rgba(217, 217, 217, 1);
				padding: 10px;

			}

			.tab {
				width: 92%;
				height: 40px;
				display: flex;
				align-items: center;
				border-top: 1px solid rgba(217, 217, 217, 1);
				border-left: 1px solid rgba(217, 217, 217, 1);
				border-right: 1px solid rgba(217, 217, 217, 1);
			}
		}
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.compare {
		color: red;
		text-decoration: line-through;
	}

	.ellipsis {
		display: -webkit-box;
		text-overflow: ellipsis;
		overflow: hidden;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.el-popover {
		height: 150px;
		overflow: auto;
	}

	/deep/.el-input--suffix .el-input__inner{
		border-radius: 25px !important;
	}
	
</style>